import { IconButton, IconButtonSize } from "shared/components/IconButton";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";

export const Header = ({
  title,
  description,
  onClose
}: {
  title: string;
  description: string;
  onClose: () => void;
}) => {
  return (
    <div className="p-6 border-b border-alpha-40 relative">
      <h1 className="text-xl font-bold text-content-1000 mb-2">{title}</h1>
      <p className="text-sm text-content-400">{description}</p>
      <IconButton
        HugeIcon={Cancel01Icon}
        size={IconButtonSize.LG}
        borderLess
        className="absolute top-2 right-2 hover:bg-transparent"
        onClick={onClose}
      />
    </div>
  );
};
